import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { isMobile, isWeiXin } from './utils/utils.js'
import config from './utils/config.js'
import { getQueryString } from './utils/utils.js'
import auth from './models/auth.js'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-ui.scss'

// import { Picker } from 'vant'

// Vue.use(Picker)
// import Popup from 'vant/lib/popup';
// import 'vant/lib/popup/style';
// Vue.use( Popup );

// import Picker from 'vant/lib/picker';
// import 'vant/lib/picker/style';
// Vue.use(Picker);

import {Toast,Form, CellGroup, Picker,Button,Popup,Field,TreeSelect,Uploader,Calendar,Dialog,Loading} from 'vant';
Vue.use(Calendar);
Vue.use(Picker);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(TreeSelect);
Vue.use(Uploader);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Form);
Vue.use(CellGroup);
Vue.use(Toast);
// import { Tabbar, TabbarItem } from 'vant';

// Vue.use(Tabbar);
// Vue.use(TabbarItem);

// import { Picker } from 'vant'

// Vue.use(Picker)
// import Popup from 'vant/lib/popup';
// import 'vant/lib/popup/style';
// Vue.use( Popup );

// import Picker from 'vant/lib/picker';
// import 'vant/lib/picker/style';
// Vue.use(Picker);

// import { Picker } from 'vant';
// Vue.use(Picker);

// import { Popup } from 'vant';
// Vue.use(Popup);

// import { Field } from 'vant';
// Vue.use(Field);

// import { TreeSelect } from 'vant';

// Vue.use(TreeSelect);

// import { Tabbar, TabbarItem } from 'vant';

// Vue.use(Tabbar);
// Vue.use(TabbarItem);

var infiniteScroll = require('vue-infinite-scroll')
Vue.use(infiniteScroll)

Vue.use(ElementUI, { locale })

Vue.use(infiniteScroll)

import imgView from 'vue-img-view'
Vue.use(imgView)
router.beforeEach((to, from, next) => {
  const href = window.location.href
  console.log(document.location.href)

  var path = to.path
  if (isWeiXin() || isMobile()) {
    config.planform = 'wap'
    if (isWeiXin()) {
      if (path === '/') {
        next({ path: '/wap' })
      } else {
        if (path.indexOf('/wap') === -1) {
          next({ path: '/wap' })
        } else {
          if (to.path === from.path) {
            next({ name: 'Empty', query: { toPath: to.fullPath }})
          } else {
            next()
          }
        }
      }
    } else {
      if (path === '/') {
        next({ path: '/wap' })
      } else {
        if (path.indexOf('/wap') === -1) {
          next({ path: '/wap' })
        } else {
          next()
        }
      }
    }
  } else {
    if (auth.gettoken()) {
      if (to.path.indexOf('/login') !== -1 || to.path.indexOf('/bind') !== -1) {
        next('/')
      } else {
        if (href.indexOf('code=') >= 0) {
          const code = getQueryString('code')
          const status = getQueryString('u')
          const tid = getQueryString('tid')
          if (status === 'bind' && !auth.code) {
            auth.code = code
            next({ path: '/user', query: { code: code, tid: tid }})
          }
        } else {
          next()
        }
        next()
      }
    } else {
      if (to.path.indexOf('/login') !== -1 || to.path.indexOf('/bind') !== -1) {
        next()
      } else {
        if (href.indexOf('code=') >= 0) {
          const code = getQueryString('code')
          const status = getQueryString('u')
          const tid = getQueryString('tid')
          const r = getQueryString('r')
          console.log(status, tid, r, code)
          if (status === 'login') {
            next({ path: '/login', query: { code: code, r: r, tid: tid }})
          } else {
            next({ path: '/bind', query: { code: code, tid: tid }})
          }
        } else {
          next()
        }
      }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
